import {
  UPDATE_INPUT_STATES,
  UPDATE_MY_STATE,
  SUBMIT_MY_STATE,
} from './types';
import { handleFailedEmit } from '../ws';

const updateInputStates = (states, updateOwnGroup) => (dispatch, getState) => {
  let ms = undefined;
  const { groupId, myState } = getState().gameStateInput;
  if (states[myState.roundNumber]) {
    ms = states[myState.roundNumber][groupId];
  }
  dispatch({ type: UPDATE_INPUT_STATES, payload: { updateOwnGroup, states, myState: ms } });
};

const updateMyState = state => (dispatch, getState) => {
  const { gameStateInput } = getState();
  if (gameStateInput.myState.joined && gameStateInput.preventInputChanges) return;
  dispatch({ type: UPDATE_MY_STATE, payload: state });
};

const finishedStep = gameStateInput => (dispatch, getState) => {
  const { group, gameStateInput: gsi } = getState();
  const payload = {
    states: gameStateInput.states,
    myLatestState: {
      ...gameStateInput.states[gsi.myLatestState.roundNumber][group.id],
      showSavedPopup: gameStateInput.step,
    },
  };
  dispatch({ type: 'FINISHED_STEP', payload });
};

const submitMyState = (step) => (dispatch, getState) => {
  const { group, schoolClass, gameStateInput } = getState();
  if (gameStateInput.myState.joined && gameStateInput.preventInputChanges) return;
  const myState = gameStateInput.myState;
  if (
    myState[step] === 'PROCESSED' ||
    myState.SIMULATION_TAX === 'SUBMITTED' ||
    myState.SIMULATION_TAX_2 === 'SUBMITTED' ||
    myState.SIMULATION_SPENDING === 'SUBMITTED'
  ) return;
  const input = {
    ...myState,
    [step]: 'SUBMITTED',
  };
  if (window.socket) {
    dispatch({ type: SUBMIT_MY_STATE, payload: input });
    window.socket.emit('updatedInput', {
      who: group.id,
      schoolClassId: schoolClass.id,
      room: `simulationgame-${schoolClass.id}`,
      input,
    }, handleFailedEmit);
  }
};

export default {
  updateInputStates,
  updateMyState,
  finishedStep,
  submitMyState,
};



// WEBPACK FOOTER //
// ./src/actions/gameStateInput.js